import styled from 'styled-components';

export const NewsHeaderContainer = styled.div`
  padding-left: ${({ theme }) => theme.spacing(2)};
  padding-right: ${({ theme }) => theme.spacing(2)};
  margin-top: ${({ theme }) => theme.spacing(4)};
  margin-bottom: ${({ theme }) => theme.spacing(4)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const TopArea = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const TagWrapper = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const Tag = styled.span`
  text-transform: uppercase;
  cursor: pointer;
  padding: ${({ theme }) => `${theme.spacing(1)} ${theme.spacing(2)}`};
  border-radius: ${({ theme }) => theme.spacing(0.1)};

  background-color: ${({ theme }) => theme.colors.secondaryLightGrey};
  color: ${({ theme }) => theme.colors.primaryDark};
`;

export const NewsTitle = styled.h1`
  color: ${({ theme }) => theme.colors.secondaryGrey};
`;

export const NewsDescription = styled.p`
  font-weight: ${({ theme }) => theme.fontWeights.light};
  font-family: ${({ theme }) => theme.fontFamilies.italianPlate};
  font-size: ${({ theme }) => theme.fontSizes.h5Mobile};
  line-height: ${({ theme }) => theme.lineHeights.h4};
  margin-top: ${({ theme }) => theme.spacing(4)};
`;

export const ContentWrapper = styled.div`
  width: 100%;
  text-align: center;

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: 80%;
    margin: 0 auto;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    width: 70%;
  }
`;
